import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const PageTitleContainer = styled.nav<{ borderBottom?: boolean; top?: number }>`
  position: sticky;
  top: ${(props) => (props.top ? `${props.top}px` : '0')};
  left: 50%;
  right: auto;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: white;
  align-items: center;
  justify-content: center;
  z-index: 4;
  border-bottom: ${(props) => props.borderBottom && `1px solid ${colors.gray100}`};

  @media (min-width: 600px) {
    max-width: 450px;
  }

  .icon-container {
    position: absolute;
    left: 12px;
  }

  .right-side {
    position: absolute;
    right: 12px;
  }
`;

export const Title = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%);
`;
